export default __webpack_public_path__ + "static/media/i_bus-gen_gn_tagless.8e17df61.svg";